import type {
  Channel,
  ChannelFilters,
  ChannelMemberResponse,
  ChannelOptions,
  ChannelSort,
} from 'stream-chat';
import { add, format, isSameDay, isSameYear } from 'date-fns';

export const chatChannelType = 'messaging';

export const getTimeStamp = (channel: Channel) => {
  let lastHours = channel.state.last_message_at?.getHours();
  let lastMinutes: string | number | undefined =
    channel.state.last_message_at?.getMinutes();
  let half = 'AM';

  if (lastHours === undefined || lastMinutes === undefined) {
    return '';
  }

  if (lastHours > 12) {
    lastHours = lastHours - 12;
    half = 'PM';
  }

  if (lastHours === 0) lastHours = 12;
  if (lastHours === 12) half = 'PM';

  if (lastMinutes.toString().length === 1) {
    lastMinutes = `0${lastMinutes}`;
  }

  return `${lastHours}:${lastMinutes} ${half}`;
};

export const getChannelName = (members: ChannelMemberResponse[]) => {
  const defaultName = 'Johnny Blaze';

  if (!members.length || members.length === 1) {
    return members[0]?.user?.name || defaultName;
  }

  return `${members[0]?.user?.name || defaultName}, ${
    members[1]?.user?.name || defaultName
  }`;
};

export const chatFormatDate = (date: Date) => {
  const now = Date.now();
  return isSameDay(now, date)
    ? format(date, 'h:mmaa')
    : isSameYear(now, date)
    ? format(date, 'MMM d')
    : format(date, 'MMM d, yyyy');
};

export const getChannelListOptions = (
  user: string | null,
  showFrozenChannels: boolean,
) => {
  const dateInTheFuture = add(new Date(), { days: 1 });
  const filters: ChannelFilters = {
    type: chatChannelType,
    members: { $in: [user] },
    last_message_at: { $lt: dateInTheFuture.toISOString() },
    frozen: { $eq: showFrozenChannels },
  };

  const options: ChannelOptions = {
    state: true,
    watch: !showFrozenChannels,
    presence: true,
    limit: 100,
  };

  const sort: ChannelSort = {
    last_message_at: -1,
  };

  return {
    filters,
    options,
    sort,
  };
};
